import { useRef, useState } from "react";
import { uploadClientPortalFile, resolveClientPortalAssetUrl } from "../../api/clientUploadApi";
import "../../styles/clientPortalUploads.css";

function ClientPortalImageUpload({
  clientViewId,
  kind,
  entityId,
  label = "Photo",
  hint,
  value,
  onChange,
  onUploaded,
  disabled = false,
}) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState("");

  const previewUrl = value ? resolveClientPortalAssetUrl(value) : "";

  const handleFile = async (event) => {
    const file = event.target.files?.[0];
    if (!file) {
      return;
    }
    setUploading(true);
    setError("");
    try {
      const body = await uploadClientPortalFile(clientViewId, file, { kind, entityId });
      if (typeof onUploaded === "function") {
        onUploaded(body.file);
      } else {
        onChange(body.file.url);
      }
    } catch (err) {
      setError(err.message || "Upload failed.");
    } finally {
      setUploading(false);
      if (inputRef.current) {
        inputRef.current.value = "";
      }
    }
  };

  return (
    <div className="cp-upload-field">
      <div className="cp-upload-field-header">
        <span className="cp-upload-label">{label}</span>
        {hint ? <span className="muted cp-upload-hint">{hint}</span> : null}
      </div>

      {previewUrl ? (
        <div className="cp-upload-preview">
          <img src={previewUrl} alt="" onError={(e) => { e.target.style.display = "none"; }} />
        </div>
      ) : null}

      <div className="cp-upload-actions">
        <button
          type="button"
          className="btn btn-secondary"
          disabled={disabled || uploading}
          onClick={() => inputRef.current?.click()}
        >
          {uploading ? "Uploading…" : previewUrl ? "Replace image" : "Upload image"}
        </button>
        {previewUrl ? (
          <button
            type="button"
            className="cv-button-link"
            disabled={disabled || uploading}
            onClick={() => onChange("")}
          >
            Remove
          </button>
        ) : null}
      </div>

      <label className="cp-upload-url-fallback">
        <span className="muted">Or paste image URL</span>
        <input
          type="url"
          className="cp-upload-url-input"
          value={value || ""}
          disabled={disabled}
          onChange={(e) => onChange(e.target.value)}
          placeholder="https://example.com/photo.jpg"
        />
      </label>

      <input
        ref={inputRef}
        type="file"
        accept="image/jpeg,image/png,image/webp,image/gif"
        className="visually-hidden"
        onChange={handleFile}
      />

      {error ? <p className="cp-upload-error">{error}</p> : null}
    </div>
  );
}

export default ClientPortalImageUpload;
